import { render } from "./SuggestPostImageDialog.vue?vue&type=template&id=51f9c599&scoped=true&ts=true"
import script from "./SuggestPostImageDialog.vue?vue&type=script&lang=ts"
export * from "./SuggestPostImageDialog.vue?vue&type=script&lang=ts"

import "./SuggestPostImageDialog.vue?vue&type=style&index=0&id=51f9c599&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f9c599"]])

export default __exports__